export class AuthRevokeToken {
    UserId?: number;
    Token?: string;
}
